module.exports = __webpack_public_path__ + "media/images/partnership-categories-names-de57ff9392f8535eabc270d9a136b7b9.png";